import { IsNotEmpty } from 'class-validator';

export class UpdateCompanyManagerBlocksFormDto {
  @IsNotEmpty()
  managerType: string;
}
